// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"d1753","icon":"_60f36","item":"_8dba3","text":"_2139f","remove":"_02481"};